import React, { useState, useEffect } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { ArticleCard } from '../components/ArticleCard';
import { articlesAPI, categoriesAPI } from '../services/api';

export const CategoryPage = () => {
  const { slug } = useParams();
  const [category, setCategory] = useState(null);
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    loadCategoryData();
  }, [slug]);

  const loadCategoryData = async () => {
    try {
      const [categoriesData, articlesData] = await Promise.all([
        categoriesAPI.getAll(),
        articlesAPI.getAll({ category: slug })
      ]);
      
      const foundCategory = categoriesData.find(cat => cat.slug === slug);
      if (!foundCategory) {
        setError(true);
      } else {
        setCategory(foundCategory);
        setArticles(articlesData);
      }
    } catch (error) {
      console.error('Error loading category:', error);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-teal-500 mx-auto"></div>
          <p className="mt-4 text-gray-600">Cargando...</p>
        </div>
      </div>
    );
  }

  if (error || !category) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="min-h-screen bg-white">
      {/* Category Header */}
      <section className="bg-gradient-to-b from-teal-50 to-white py-16 border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {category.name}
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-6">
            {category.description}
          </p>
          <p className="text-sm text-gray-500">
            {articles.length} {articles.length === 1 ? 'artículo' : 'artículos'} disponibles
          </p>
        </div>
      </section>

      {/* Articles Grid */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {articles.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {articles.map((article) => (
                <ArticleCard key={article.id} article={article} />
              ))}
            </div>
          ) : (
            <div className="text-center py-16">
              <p className="text-gray-500 text-lg">
                No hay artículos disponibles en esta categoría todavía.
              </p>
            </div>
          )}
        </div>
      </section>
    </div>
  );
};
